"use client";

import Button from "@/components/atom/Button";
import Container from "@/components/atom/Container";
import Dropdown from "@/components/atom/Dropdown";
import Loading from "@/components/atom/Loading";
import { CardProduct } from "@/components/sub-atom/Card";
import { getBrand, getProduct, getSpecialMenu } from "@/functions/databaseData";
import useHeader from "@/functions/useHeader";
import {
  CheckboxCheckedSvg,
  CheckboxUncheckSvg,
  ChevronDownSvg,
  ChevronUpSvg,
  CloseSolidSvg,
  FilterOutlineSvg,
} from "@/public/svg";
import { useEffect, useMemo, useState } from "react";
import uniqBy from "lodash/uniqBy";

export default function SearchId({ params }) {
  const { session, status } = useHeader();
  const { search_id } = params;
  let searchId = decodeURIComponent(search_id?.[search_id.length > 1 ? 1 : 0]);
  const [numPage, setNumPage] = useState(1);
  const [disableNextPage, setDisableNextPage] = useState(false);

  const [datas, setDatas] = useState({
    brand: [],
    products: [],
    specialMenu: [],
  });
  const [filter, setFilter] = useState({
    type: "",
    datas: [],
    refresh: false,
  });
  const [loading, setLoading] = useState({
    getAllDatas: false,
  });
  const [show, setShow] = useState({
    brand: true,
    specialMenu: true,
    sort: false,
  });

  useEffect(() => {
    async function run() {
      setLoading((old) => ({ ...old, getAllDatas: true }));
      try {
        const datasSpecialMenu = await getSpecialMenu();

        let obj = {
          mode:
            search_id?.length > 1
              ? search_id?.[0] == "special-menu"
                ? "specialMenu"
                : search_id?.[0]
              : "search",
          value:
            search_id?.[0] == "special-menu"
              ? datasSpecialMenu.find((a) => a.name_menu == searchId)?.code_menu
              : searchId,
          token: session?.user?.token,
        };

        const [datasBrand, datasProduct] = await Promise.all([
          getBrand(),
          getProduct(obj),
        ]);
        setDatas({
          brand: datasBrand,
          products: datasProduct,
          specialMenu: datasSpecialMenu,
        });

        setFilter((old) => ({
          type:
            search_id?.length > 1
              ? search_id?.[0] == "special-menu"
              ? "specialMenu"
              : search_id?.[0]
              : "search",
          datas:
            search_id?.[0] == "brand"
              ? [searchId]
              : search_id?.[0] == "special-menu"
              ? [
                  datasSpecialMenu.find((a) => a.name_menu == searchId)
                    ?.code_menu || "",
                ]
              : [],
          refresh: true,
        }));
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading((old) => ({ ...old, getAllDatas: false }));
      }
    }

    if (!loading?.getAllDatas) run();
  }, [session?.user?.token]);

  async function getFilterProduct({ mode, value, page = 1 }) {
    setLoading((old) => ({ ...old, getFilterProduct: true }));
    try {
      const filterProduct = await getProduct({
        mode: !value ? "" : mode,
        value: value,
        page: page,
        token: session?.user?.token,
        methodNextFetch: { cache: "force-cache" },
      });

      setDisableNextPage(false);
      setDatas((old) => ({
        ...old,
        products: filterProduct,
      }));
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading((old) => ({ ...old, getFilterProduct: false }));
    }
  }

  async function resetFilter() {
    try {
      setLoading((old) => ({ ...old, resetFilter: true }));

      const datasProduct = await getProduct({
        mode: "search",
        value: searchId,
        token: session?.user?.token,
        methodNextFetch: { cache: "force-cache" },
      });
      setFilter({
        refresh: true,
      });
      setDatas((old) => ({
        ...old,
        products: datasProduct,
      }));
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading((old) => ({ ...old, resetFilter: false }));
    }
  }

  const isListFilter = useMemo(
    () => (filter?.datas?.length > 0 ? [...filter?.datas, "_"] : []),
    [filter?.datas]
  );

  async function nextPage(num) {
    setLoading((old) => ({ ...old, nextPage: true }));
    try {
      let payload = {
        mode:
          filter.datas?.filter((a) => a).length > 0
            ? filter.type
            : search_id?.length > 1
            ? search_id?.[0] == "special-menu"
              ? "specialMenu"
              : search_id?.[0]
            : "search",
        value:
          filter.datas?.filter((a) => a).length > 0
            ? filter.datas.join()
            : search_id?.[0] == "special-menu"
            ? datas.specialMenu.find((a) => a.name_menu == searchId)?.code_menu
            : searchId,
        token: session?.user?.token,
        page: num,
        methodNextFetch: { cache: "no-store" },
      };

      let datasPerPage = await getProduct(payload);
      let stock = datasPerPage?.filter((item) => item?.stock > 0) ?? [];
      let emptyStock = datasPerPage?.filter((item) => item?.stock <= 0) ?? [];

      let isDataOld = {};

      isDataOld.stock = stock?.length > 0 ? stock : [];
      isDataOld.emptyStock = emptyStock?.length > 0 ? emptyStock : [];

      setDatas((val) => ({
        ...val,
        products:
          val?.products?.length > 0
            ? uniqBy(
                [
                  ...val?.products,
                  ...isDataOld?.stock,
                  ...isDataOld?.emptyStock,
                ],
                "_id"
              )
            : uniqBy([...isDataOld?.stock, ...isDataOld?.emptyStock], "_id"),
      }));

      setNumPage(num);
      // disable next page jika data terakhir page kosong
      if (num > 1 && datasPerPage?.length <= 0) setDisableNextPage(true);
    } catch (error) {
      console.log(`error next page : ${error?.message}`);
    } finally {
      setLoading((old) => ({ ...old, nextPage: false }));
    }
  }

  return (
    <Container showMQ={false} className={"relative "}>
      <div className="flex px-gon w-screen gap-10 bg-shadesGON-50 my-6">
        <div className="hidden md:flex w-full md:max-w-[20%] min-h-screen">
          <div className="w-full flex flex-col gap-6 p-6 h-fit border border-greyscaleGON-200 rounded-lg ">
            <p className="h6-semiBold text-greyscaleGON-500">Filter</p>

            {/* list filter special menu */}
            <div className="flex flex-col gap-4">
              <div
                onClick={() =>
                  setShow((old) => ({
                    ...old,
                    specialMenu: !show?.specialMenu,
                  }))
                }
                className="flex justify-between py-3 cursor-pointer items-start"
              >
                <p className="text-div-small text-greyscaleGON-700 ">
                  Filter Menu
                </p>
                <div>
                  {!show?.specialMenu ? (
                    <ChevronDownSvg className="h-6 w-6 text-greyscaleGON-700" />
                  ) : (
                    <ChevronUpSvg className="h-6 w-6 text-greyscaleGON-700" />
                  )}
                </div>
              </div>
              {show?.specialMenu &&
                datas?.specialMenu?.map((item, key) => {
                  return (
                    <div
                      key={key}
                      onClick={(e) => {
                        e.preventDefault();
                        const index = filter.datas?.indexOf(item?.code_menu);
                        if (index > -1) {
                          const isFilter = filter.datas?.filter(
                            (val) => val !== item?.code_menu
                          );
                          getFilterProduct({
                            mode: "specialMenu",
                            value: isFilter?.join(),
                          });
                          return setFilter({
                            type: "specialMenu",
                            datas: isFilter,
                          });
                        }

                        getFilterProduct({
                          mode: "specialMenu",
                          value: item?.code_menu,
                        });
                        setFilter((old) => ({
                          type: "specialMenu",
                          datas: [item?.code_menu],
                        }));
                      }}
                      className="flex p-2 gap-3 items-center w-full hover:cursor-pointer"
                    >
                      <div>
                        {filter.datas?.indexOf(item?.code_menu) > -1 ? (
                          <CheckboxCheckedSvg className="h-6 w-6 md:h-6 md:w-6 text-primaryGON-400" />
                        ) : (
                          <CheckboxUncheckSvg className="h-6 w-6 md:h-6 md:w-6 text-greyscaleGON-500" />
                        )}
                      </div>
                      <p className="p1-regular text-greyscaleGON-500 capitalize">
                        {item?.name_menu}
                      </p>
                    </div>
                  );
                })}
            </div>

            {/* list filter brand */}
            <div className="flex flex-col gap-4">
              <div
                onClick={() =>
                  setShow((old) => ({ ...old, brand: !show?.brand }))
                }
                className="flex justify-between py-3 cursor-pointer items-start"
              >
                <p className="text-div-small text-greyscaleGON-700">
                  Filter Brand
                </p>
                <div>
                  {!show?.brand ? (
                    <ChevronDownSvg className="h-6 w-6 text-greyscaleGON-700" />
                  ) : (
                    <ChevronUpSvg className="h-6 w-6 text-greyscaleGON-700" />
                  )}
                </div>
              </div>
              {show?.brand &&
                datas?.brand?.map((item, key) => {
                  return (
                    <div
                      key={key}
                      onClick={(e) => {
                        e.preventDefault();
                        const index = filter.datas?.indexOf(item?.name_brand);
                        if (index > -1) {
                          const isFilter = filter.datas?.filter(
                            (val) => val !== item?.name_brand
                          );
                          getFilterProduct({
                            mode: "brand",
                            value: isFilter.join(),
                          });
                          return setFilter({
                            type: "brand",
                            datas: isFilter,
                          });
                        }
                        getFilterProduct({
                          mode: "brand",
                          value:
                            filter?.datas?.length > 0 && filter?.type == "brand"
                              ? [...filter?.datas, item?.name_brand]?.join()
                              : item?.name_brand,
                        });
                        setFilter((old) => ({
                          type: "brand",
                          datas:
                            old?.datas?.length > 0 && filter?.type == "brand"
                              ? [...old?.datas, item?.name_brand]
                              : [item?.name_brand],
                        }));
                      }}
                      className="flex p-2 gap-3 items-center w-full hover:cursor-pointer"
                    >
                      <div>
                        {filter.datas?.indexOf(item?.name_brand) > -1 ? (
                          <CheckboxCheckedSvg className="h-6 w-6 md:h-6 md:w-6 text-primaryGON-400" />
                        ) : (
                          <CheckboxUncheckSvg className="h-6 w-6 md:h-6 md:w-6 text-greyscaleGON-500" />
                        )}
                      </div>
                      <p className="p1-regular text-greyscaleGON-500 capitalize">
                        {item?.name_brand}
                      </p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        {status == "loading" ? (
          <Loading className={"h-screen md:h-1/2 w-full md:max-w-[70%]"} />
        ) : (
          <div className="flex flex-col gap-4 w-full md:max-w-[70%]">
            <div className="flex justify-between">
              <p className="p1-medium text-greyscaleGON-700">
                {filter?.datas?.length > 0
                  ? "Hasil Pencarian untuk"
                  : "List Produk Search"}
              </p>
              <div
                className="flex md:hidden gap-1 items-center text-primaryGON-400 cursor-pointer"
                onClick={() =>
                  setShow({
                    all: true,
                  })
                }
              >
                <FilterOutlineSvg className="h-7 w-7" />
                <p className="p1-medium ">Filter</p>
              </div>
            </div>
            <div className="flex flex-col gap-5">
              <div className="flex flex-wrap gap-2 xs:gap-2">
                {isListFilter?.map((item, index) => {
                  const deleteButton =
                    index + 1 === [...filter?.datas, "_"].length;
                  const isLabel =
                    filter?.type == "specialMenu"
                      ? datas?.specialMenu?.filter(
                          (val) => val?.code_menu == item
                        )[0]?.name_menu
                      : item;

                  return deleteButton ? (
                    <Button
                      key={index}
                      label="Delete All"
                      variants="text"
                      onClick={resetFilter}
                    />
                  ) : (
                    <Button
                      key={index}
                      label={isLabel}
                      colors={"greyscale"}
                      onClick={() => {
                        const isFilter = filter.datas?.filter(
                          (val) => val !== item
                        );
                        getFilterProduct({
                          mode: filter?.type,
                          value: isFilter.join(),
                        });
                        setFilter((old) => ({ ...old, datas: isFilter }));
                      }}
                      className={
                        "bg-greyscaleGON-50 text-greyscaleGON-400 hover:text-shadesGON-50 border-greyscaleGON-200 rounded-lg"
                      }
                      variants={"solid"}
                      icon={{
                        right: (props) => <CloseSolidSvg {...props} />,
                      }}
                    />
                  );
                })}
              </div>
              {loading?.getAllDatas || datas?.products?.length <= 0 ? (
                <p className="text-button-small text-gray-400">
                  {loading?.getAllDatas
                    ? "loading..."
                    : datas?.products?.length <= 0
                    ? "not found"
                    : ""}
                </p>
              ) : (
                <>
                  <div className="grid-product-list-search">
                    {datas?.products?.map((item, index) => (
                      <CardProduct
                        id={"search"}
                        imgHeight="max-h-[160px]"
                        item={item}
                        key={index}
                      />
                    ))}
                  </div>
                  <div className="flex w-full justify-center items-center py-10">
                    {!disableNextPage && (
                      <Button
                        className="min-w-[12px]"
                        disable={disableNextPage || loading?.nextPage}
                        loading={loading?.nextPage}
                        variants="outline"
                        label={`Muat Lebih Banyak`}
                        onClick={() => nextPage && nextPage(numPage + 1)}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      <Dropdown
        show={show?.all}
        className={
          "flex fixed z-40 md:hidden bg-shadesGON-50 w-screen h-screen overflow-hidden overflow-y-scroll"
        }
      >
        <div className="w-full flex flex-col gap-6 p-6 h-fit rounded-lg ">
          <div className="flex items-center justify-between">
            <p className="h6-semiBold text-greyscaleGON-500">Filter</p>
            <div
              className="flex md:hidden gap-1 items-center text-primaryGON-400 cursor-pointer"
              onClick={() =>
                setShow({
                  all: false,
                })
              }
            >
              <p className="p1-medium ">Tutup</p>
            </div>
          </div>

          {/* list filter special menu */}
          <div className="flex flex-col gap-4">
            <div
              onClick={() =>
                setShow((old) => ({
                  ...old,
                  specialMenu: !show?.specialMenu,
                }))
              }
              className="flex justify-between py-3 cursor-pointer items-start"
            >
              <p className="text-div-small text-greyscaleGON-700">
                Filter Menu
              </p>
              {!show?.specialMenu ? (
                <ChevronDownSvg className="h-6 w-6 text-greyscaleGON-700" />
              ) : (
                <ChevronUpSvg className="h-6 w-6 text-greyscaleGON-700" />
              )}
            </div>
            {show?.specialMenu &&
              datas?.specialMenu?.map((item, key) => {
                return (
                  <div
                    key={key}
                    onClick={(e) => {
                      e.preventDefault();
                      const index = filter.datas?.indexOf(item?.code_menu);
                      if (index > -1) {
                        const isFilter = filter.datas?.filter(
                          (val) => val !== item?.code_menu
                        );
                        getFilterProduct({
                          mode: "specialMenu",
                          value: isFilter.join(),
                        });
                        return setFilter({
                          type: "specialMenu",
                          datas: isFilter,
                        });
                      }
                      getFilterProduct({
                        mode: "specialMenu",
                        value: item?.code_menu,
                      });
                      setFilter((old) => ({
                        type: "specialMenu",
                        datas: [item?.code_menu],
                      }));
                    }}
                    className="flex p-2 gap-3 items-center w-full hover:cursor-pointer"
                  >
                    {filter.datas?.indexOf(item?.code_menu) > -1 ? (
                      <CheckboxCheckedSvg className="h-6 w-6 md:h-6 md:w-6 text-primaryGON-400" />
                    ) : (
                      <CheckboxUncheckSvg className="h-6 w-6 md:h-6 md:w-6 text-greyscaleGON-500" />
                    )}
                    <p className="p1-regular text-greyscaleGON-500 capitalize">
                      {item?.name_menu}
                    </p>
                  </div>
                );
              })}
          </div>

          {/* list filter brand */}
          <div className="flex flex-col gap-4">
            <div
              onClick={() =>
                setShow((old) => ({ ...old, brand: !show?.brand }))
              }
              className="flex justify-between py-3 cursor-pointer items-start"
            >
              <p className="text-div-small text-greyscaleGON-700">
                Filter Brand
              </p>
              {!show?.brand ? (
                <ChevronDownSvg className="h-6 w-6 text-greyscaleGON-700" />
              ) : (
                <ChevronUpSvg className="h-6 w-6 text-greyscaleGON-700" />
              )}
            </div>
            {show?.brand &&
              datas?.brand?.map((item, key) => {
                return (
                  <div
                    key={key}
                    onClick={(e) => {
                      e.preventDefault();
                      const index = filter.datas?.indexOf(item?.name_brand);
                      if (index > -1) {
                        const isFilter = filter.datas?.filter(
                          (val) => val !== item?.name_brand
                        );

                        getFilterProduct({
                          mode: "brand",
                          value: isFilter?.join(),
                        });
                        return setFilter({
                          type: "brand",
                          datas: isFilter,
                        });
                      }

                      getFilterProduct({
                        mode: "brand",
                        value:
                          filter?.datas?.length > 0 && filter?.type == "brand"
                            ? [...filter?.datas, item?.name_brand]?.join()
                            : item?.name_brand,
                      });
                      setFilter((old) => ({
                        type: "brand",
                        datas:
                          old?.datas?.length > 0 && filter?.type == "brand"
                            ? [...old?.datas, item?.name_brand]
                            : [item?.name_brand],
                      }));
                    }}
                    className="flex p-2 gap-3 items-center w-full hover:cursor-pointer"
                  >
                    {filter.datas?.indexOf(item?.name_brand) > -1 ? (
                      <CheckboxCheckedSvg className="h-6 w-6 md:h-6 md:w-6 text-primaryGON-400" />
                    ) : (
                      <CheckboxUncheckSvg className="h-6 w-6 md:h-6 md:w-6 text-greyscaleGON-500" />
                    )}
                    <p className="p1-regular text-greyscaleGON-500 capitalize">
                      {item?.name_brand}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
      </Dropdown>
    </Container>
  );
}
